//Get Process Name Variables types
export const GET_PROCESSNAME_REQUEST="GET_PROCESSNAME_REQUEST";
export const GET_PROCESSNAME_SUCCESS="GET_PROCESSNAME_SUCCESS";
export const GET_PROCESSNAME_FAILURE="GET_PROCESSNAME_FAILURE";